<template>
    <s-v-g-icon :width="width" :height="height" view-box="0 0 512 512">
        <path d="m496.544 241.137c-113.228-184.556-381.141-184.259-494.182 0-3.149 5.134-3.149 11.601 0 16.734 113.042 184.261 381.123 184.281 494.182 0 3.149-5.134 3.149-11.6 0-16.734zm-461.547 8.367c102.171-152.928 326.785-152.855 428.912 0-102.151 152.892-326.763 152.896-428.912 0z"/><path d="m321.246 214.595c-4.131 2.444-8.862 3.736-13.684 3.736-20.831 0-33.762-22.771-23.2-40.62 5.398-9.12.586-20.91-9.688-23.62-62.925-16.6-123.903 31.177-123.903 95.413 0 54.413 44.269 98.682 98.682 98.682 64.294 0 111.996-61.044 95.413-123.903-2.705-10.254-14.486-15.097-23.62-9.688zm-71.793 101.591c-36.769 0-66.682-29.913-66.682-66.682 0-36.701 29.806-66.572 66.481-66.682-5.739 39.014 27.893 72.617 66.882 66.882-.109 36.676-29.98 66.482-66.681 66.482z"/>
    </s-v-g-icon>
</template>

<script>
    import SVGIcon from "../../../components/SVGIcon";
    export default {
        name: "ViewabilityIcon",
        components: {SVGIcon},
        props:{
            width: {
                type: [Number, String],
                default: 32
            },
            height: {
                type: [Number, String],
                default: 32
            },
            color: {
                type: String,
                default: 'currentColor'
            },
        }
    }
</script>

<style scoped>

</style>
